<ng-template [ngIf]="isEdit">
    <div class="modal-header">

        <p class="modal-title"><strong>Amend drop down</strong></p>
         <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

    </div>

    <div class="modal-body p-3">
        <form [formGroup]="amendLookup" class="d-flex justify-content-start flex-column">
            <div class="w-100 mb-2">
                <label>Order *</label>
                <input type="number" class="w-35 form-control form-control-sm" formControlName="order" />
            </div>

            <div class="w-100 mb-2">
                <label>{{ isDefaultText ? 'Display Text' : 'Document Name (Display Text)' }}  *</label>
                <textarea class="w-35 form-control form-control-sm" formControlName="displayText"></textarea>
            </div>
            <div class="w-100 mb-2" *ngIf="this.lookupField.lookupTypeId == 48">
                <label> Document Name (Value) - CM9 *</label>
                <textarea class="w-35 form-control form-control-sm" formControlName="value"></textarea>
            </div>
            <div class="w-100 mb-2" *ngIf="this.lookupField.lookupTypeId == 48">
                    <label>Document Type *</label>
                    <div class="m-0 mr-3 w-35">
                        <ng-select [items]="documentTypes" formControlName="parentFieldId" bindLabel="displayText" bindValue="id"
                            [placeholder]="'Select'">
                        </ng-select>
                    </div>
            </div>
            <div class="w-100 mb-2" *ngIf="this.lookupField.lookupTypeId !== 48 && this.lookupField.lookupTypeId !== 47">
                <label for="active">
                    <input id="active" type="checkbox" formControlName="isActive" />
                    Active
                </label>
            </div>
            <div class="row" *ngIf="this.lookupField.lookupTypeId == 38">
                <div class="col-md-5">
                    <label>Mapping Field</label>
                    <ng-select [items]="mappingLookUps" formControlName="mappingLookUpFieldId" bindLabel="value"
                        bindValue="id" [placeholder]="'Select'" (change)="onlookUpChange($event)">
                    </ng-select>
                </div>
                <div class="col-md-5" *ngIf="this.amendLookup.get('mappingLookUpFieldId').value == 21">
                    <label>Value</label>
                    <ng-multiselect-dropdown id="ict" class="form-control form-control-sm"
                        placeholder="Select Immigration Case Type" [data]="immigrationCaseTypes$ | async"
                        [settings]="ictSettings" formControlName="ict">
                    </ng-multiselect-dropdown>
                </div>
            </div>
        </form>
    </div>

    <div class="text-center p-3">
        <button class="btn btn-outline-primary me-2" (click)="modal.dismiss()">Close</button>
        <button (click)="onUpdate()" eosDebounce [disabled]="!amendLookup.valid" class="btn btn-secondary"
            type="submit">Update</button>
    </div>

</ng-template>


<ng-template [ngIf]="!isEdit">
    <div class="modal-header">
        <p class="modal-title"><strong>Create new drop down</strong></p>
     <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

    </div>
    <div class="modal-body p-3">
        <form [formGroup]="createForm" class="d-flex flex-column row">
            <div class="row m-0">
                <div class="col mb-2">
                    <label>Drop down type*</label>
                    <div class="m-0 mr-3 w-35">
                        <ng-select [items]="lktypes" [closeOnSelect]="true" [multiple]="false" bindLabel="displayText"
                            bindValue="id" formControlName="lookupTypeId" (click)="onDropdownChange($event)">
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                    <span class="ng-value-label">
                                        {{item.displayText}}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 3">
                                    <span class="ng-value-label">+{{items.length - 3}}</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="row m-0">
                <div class="col mb-2">
                    <label>Order *</label>
                    <input type="number" class="w-35 form-control form-control-sm" formControlName="order" />
                </div>
            </div>
            <div class="row m-0">
                <div class="col mb-2">
                    <label>{{ isDefaultText ? 'Display Text' : 'Document Name (Display Text)' }}  *</label>
                    <input type="text" class="w-35 form-control form-control-sm" formControlName="displayText" />
                </div>
            </div>
            <div class="row m-0" *ngIf="this.createForm.get('lookupTypeId').value == 48">
                <div class="col mb-2">
                    <label>Document Name (Value) - CM9 *</label>
                    <input type="text" class="w-35 form-control form-control-sm" formControlName="value" />
                </div>
            </div>
            <div class="row m-0" *ngIf="this.createForm.get('lookupTypeId').value == 48">
                <div class="col mb-2">
                    <label>Document Type *</label>
                    <div class="m-0 mr-3 w-35">
                        <ng-select [items]="documentTypes" formControlName="parentFieldId" bindLabel="displayText" bindValue="id"
                            [placeholder]="'Select'">
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="row m-0">
                <div class="col mb-2">
                    <label for="active">
                        <input id="active" type="checkbox" formControlName="isActive" />
                        Active
                    </label>
                </div>
            </div>
            <div class="row m-0" *ngIf="this.createForm.get('lookupTypeId').value == 38">
                <div class="col-md-5">
                    <label>Mapping field</label>
                    <ng-select [items]="mappingLookUps" formControlName="mappingLookUpFieldId" bindLabel="value"
                        bindValue="id" [placeholder]="'Select'" (change)="onlookUpChange($event)">
                    </ng-select>
                </div>
                <div class="col-md-5" *ngIf="this.createForm.get('mappingLookUpFieldId').value == 21">
                    <label for="ict">Value</label>
                    <ng-multiselect-dropdown id="ict" class="form-control form-control-sm"
                        placeholder="Select Immigration Case Type" [data]="immigrationCaseTypes$ | async"
                        [settings]="ictSettings" formControlName="ict">
                    </ng-multiselect-dropdown>
                </div>
            </div>
            <!-- <div class="w-100 mb-2">
                <label>Employee category</label>
                <textarea class="w-100 form-control form-control-sm" formControlName="propertyExtensions"></textarea>
            </div> -->
            <div class="text-center p-3">
                <button class="btn btn-outline-primary me-2" (click)="modal.dismiss()">Close</button>
                <button (click)="onSave()" eosDebounce [disabled]="!createForm.valid" class="btn btn-secondary"
                    type="submit">Create</button>
            </div>

        </form>
    </div>

</ng-template>
